<template>
  <div class="txt">
    <el-row type="flex" justify="center" :gutter="8">
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="one">
          <a href="http://apppack.fiio.net/QQMusic.apk">
            <el-image :src="require('@/assets/img/QQmusic.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/QQMusic.apk">
          <label for="">QQ音乐</label>
        </a>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="two">
          <a href="http://apppack.fiio.net/NeteaseCloud.apk">
            <el-image :src="require('@/assets/img/wyyMusic.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/NeteaseCloud.apk">
          <label>网易云音乐</label>
        </a>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="three">
          <a href="http://apppack.fiio.net/HiByMusic.apk">
            <el-image :src="require('@/assets/img/hbMusic.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/HiByMusic.apk">
          <label>海贝音乐</label>
        </a>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center" :gutter="8">
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="two">
          <a href="http://apppack.fiio.net/BaiduMusic.apk">
            <el-image :src="require('@/assets/img/baiduMusic.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/BaiduMusic.apk">
          <label>百度音乐</label>
        </a>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="three">
          <a href="http://apppack.fiio.net/XiamiMusic.apk">
            <el-image :src="require('@/assets/img/xiamiMusic.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/XiamiMusic.apk">
          <label>虾米音乐</label>
        </a>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="one">
          <a href="http://apppack.fiio.net/NeutronMP_NEON.apk">
            <el-image
              :src="require('@/assets/img/Nettroncode.png')"
              fit="cover"
            >
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/NeutronMP_NEON.apk">
          <label class="NeutronMP">NeutronMP_NEON</label>
        </a>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center" :gutter="8">
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="one">
          <a href="http://apppack.fiio.net/BaiduInput.apk">
            <el-image :src="require('@/assets/img/baidu.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/BaiduInput.apk">
          <label>百度输入法</label>
        </a>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="two">
          <a href="http://apppack.fiio.net/Onkyo.apk">
            <el-image :src="require('@/assets/img/Onkyo.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/Onkyo.apk">
          <label>Onkyo</label>
        </a>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="three">
          <a href="http://apppack.fiio.net/JOOX.apk">
            <el-image :src="require('@/assets/img/Joox.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/JOOX.apk">
          <label>JOOX</label>
        </a>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center" :gutter="8">
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="one">
          <a href="http://apppack.fiio.net/KKBOX.apk">
            <el-image :src="require('@/assets/img/KKBOX.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/KKBOX.apk">
          <label>KKBOX</label>
        </a>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="two">
          <a href="http://apppack.fiio.net/MOOV.apk">
            <el-image :src="require('@/assets/img/MOOV.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/MOOV.apk">
          <label>MOOV</label>
        </a>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="three">
          <a href="http://apppack.fiio.net/Neutroncode.apk">
            <el-image :src="require('@/assets/img/NeutMusic.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/Neutroncode.apk">
          <label>Neutroncode</label>
        </a>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center" :gutter="8">
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="one">
          <a href="http://apppack.fiio.net/Poweramp.apk">
            <el-image :src="require('@/assets/img/Poweramp.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/Poweramp.apk">
          <label>Poweramp</label>
        </a>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="two">
          <a href="http://apppack.fiio.net/Rockbox.apk">
            <el-image :src="require('@/assets/img/Rockbox.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/Rockbox.apk">
          <label>Rockbox</label>
        </a>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="three">
          <a href="http://apppack.fiio.net/Spotify.apk">
            <el-image :src="require('@/assets/img/Spotify.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/Spotify.apk">
          <label>Spotify</label>
        </a>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center" :gutter="8">
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="one">
          <a href="http://apppack.fiio.net/SwiftKey.apk">
            <el-image :src="require('@/assets/img/Swiftkey.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/SwiftKey.apk">
          <label>Swiftkey</label>
        </a>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="two">
          <a href="http://apppack.fiio.net/TIDAL.apk">
            <el-image :src="require('@/assets/img/TIDAL.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/TIDAL.apk">
          <label>TIDAL</label>
        </a>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="three">
          <a href="http://apppack.fiio.net/BaiduCloud.apk">
            <el-image :src="require('@/assets/img/baiduyun.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/BaiduCloud.apk">
          <label>百度云</label>
        </a>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center" :gutter="8">
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="one">
          <a href="http://apppack.fiio.net/Wandoujia.apk">
            <el-image :src="require('@/assets/img/wandoujia.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/Wandoujia.apk">
          <label>豌豆荚</label>
        </a>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="two">
          <a href="http://apppack.fiio.net/Qobuz.apk">
            <el-image :src="require('@/assets/img/Qobuz.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/Qobuz.apk">
          <label>Qobuz</label>
        </a>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="three">
          <a href="http://apppack.fiio.net/TTMusic.apk">
            <el-image :src="require('@/assets/img/tiantian.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/TTMusic.apk">
          <label>天天动听</label>
        </a>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center" :gutter="8">
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="one">
          <a href="http://apppack.fiio.net/WiFi.apk">
            <el-image :src="require('@/assets/img/WiFi.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/WiFi.apk">
          <label>WiFi分析仪</label>
        </a>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="two">
          <a href="http://apppack.fiio.net/KuwoMusic.apk">
            <el-image :src="require('@/assets/img/kuwo.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/KuwoMusic.apk">
          <label>酷我音乐</label>
        </a>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="three">
          <a href="http://apppack.fiio.net/UCBrowser.apk">
            <el-image :src="require('@/assets/img/uc.png')" fit="cover">
            </el-image>
          </a>
        </div>
        <a href="http://apppack.fiio.net/UCBrowser.apk">
          <label>UC浏览器</label>
        </a>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  created() {},
  data() {
    return {
      imgUrl: "~@/assets/img/QQmusic.png"
    };
  }
};
</script>

<style lang="scss">
.txt {
  text-align: center;

  a {
    font-weight: 700;
    color: rgb(174, 8, 36);
    text-decoration: none;
  }
}
</style>
